
    import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
    @Component
    export default class SearchBuddhistName extends Vue {
      private buddhistName: string = ''
      @Emit('getBuddhistName')
       sendBuddhistName(buddhistName:string){}
    }
